module.exports = __webpack_public_path__ + "293d132f569d5d1ff0021e864d340420.svg";